// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.step-container-horizontal {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  overflow-x: auto; /* Allows horizontal scrolling for many steps */
  padding: 10px;
}

.step-horizontal {
  display: flex;
  align-items: center;
}

.step-icon {
  margin-right: 10px;
}

.step-label {
  display: flex;
  align-items: center;
  gap: 30px;
  white-space: nowrap;       
  overflow: hidden;         
  text-overflow: ellipsis; 
  max-width: 150px;  
  font-weight: 500;
}

.custom-checkbox input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: white;
  border: 2px solid #0d4473;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  display: inline-block;
  position: relative;
}

.custom-checkbox input[type="checkbox"]:checked {
  background-color: #0d4473;
  border: 2px solid #0d4473;
}

.custom-checkbox input[type="checkbox"]::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 4px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  display: none;
}

.custom-checkbox input[type="checkbox"]:checked::after {
  display: block;
}

.step-arrow-horizontal {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
}

.arrow-line-horizontal {
  width: 30px;
  height: 2px;
  background-color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/components/HSN/hierarchy.css"],"names":[],"mappings":";;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB,EAAE,+CAA+C;EACjE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB","sourcesContent":["\n\n.step-container-horizontal {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  overflow-x: auto; /* Allows horizontal scrolling for many steps */\n  padding: 10px;\n}\n\n.step-horizontal {\n  display: flex;\n  align-items: center;\n}\n\n.step-icon {\n  margin-right: 10px;\n}\n\n.step-label {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  white-space: nowrap;       \n  overflow: hidden;         \n  text-overflow: ellipsis; \n  max-width: 150px;  \n  font-weight: 500;\n}\n\n.custom-checkbox input[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  border: 2px solid #0d4473;\n  border-radius: 3px;\n  cursor: pointer;\n  outline: none;\n  display: inline-block;\n  position: relative;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked {\n  background-color: #0d4473;\n  border: 2px solid #0d4473;\n}\n\n.custom-checkbox input[type=\"checkbox\"]::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 4px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  display: none;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked::after {\n  display: block;\n}\n\n.step-arrow-horizontal {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.arrow-line-horizontal {\n  width: 30px;\n  height: 2px;\n  background-color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
